<ng-container *ngIf="step === 'login'">
  <h1 class="display-3 mb-20">Login</h1>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-group">
      <label for="email" class="form-label">Email</label>
      <input
        id="email"
        [(ngModel)]="model.username"
        formControlName="email"
        type="email"
        class="form-control"
        placeholder="Your Email"
        aria-autocomplete="inline" />
      <input-errors [control]="form.controls.email" [service]="validationService"></input-errors>
    </div>
    <div class="form-group position-relative">
      <label for="password" class="form-label">Password</label>
      <input
        id="password"
        [(ngModel)]="model.password"
        formControlName="password"
        [type]="shouldPasswordBeShown ? 'text' : 'password'"
        class="form-control"
        placeholder="Your Password"
        aria-autocomplete="inline" />
      <span
        class="icon position-absolute"
        (click)="togglePasswordShow()"
        [ngClass]="{ 'icon-show': shouldPasswordBeShown, 'icon-hide': !shouldPasswordBeShown }"></span>
      <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid || spinner">
      <ng-container *ngIf="!spinner">Log in</ng-container>
      <i *ngIf="spinner" class="icon icon-wait spin"></i>
    </button>
  </form>
</ng-container>

<ng-container *ngIf="step === 'mfa'">
  <h1 class="display-3 mb-20">Verify it's you</h1>
  <form [formGroup]="form">
    <ng-container *ngIf="mfaType === 'totp'">
      <p class="text-center">Enter the 6-digit code that we sent to Google Authenticator.</p>
    </ng-container>
    <ng-container *ngIf="mfaType === 'email'">
      <p class="text-center">We have sent you an email with a confirmation code.</p>
    </ng-container>
    <div class="form-group position-relative mb-1">
      <label for="MFA Input" class="form-label">Enter verification code</label>
      <input
        #mfaInput
        [(ngModel)]="model.mfaCode"
        (paste)="onMfaPaste($event)"
        formControlName="mfaCode"
        type="text"
        class="form-control"
        placeholder="Enter the 6 digit code" />
      <input-errors [control]="form.controls.mfaCode" [service]="validationService"></input-errors>
    </div>
    <div class="form-group d-flex align-items-center">
      <div class="form-check form-switch">
        <input #rememberDevice type="checkbox" class="form-check-input" [(ngModel)]="model.rememberDevice" formControlName="rememberDevice" />
      </div>
      <label class="form-label m-0 pointer" (click)="rememberDevice.click()">Remember device</label>
    </div>
    <ng-container *ngIf="mfaType === 'totp'">
      <button class="btn btn-primary" [disabled]="!form.valid || spinner" (click)="onSubmit()">
        <ng-container *ngIf="!spinner">Submit</ng-container>
        <i *ngIf="spinner" class="icon icon-wait spin"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="mfaType === 'email'">
      <button type="submit" class="btn btn-primary mb-10" [disabled]="!form.valid || spinner || spinnerResendEmail" (click)="onSubmit()">
        <ng-container *ngIf="!spinner">Submit</ng-container>
        <i *ngIf="spinner" class="icon icon-wait spin"></i>
      </button>
      <button
        class="btn btn-link mb-20"
        *ngIf="emailCodeResendTimeout"
        [disabled]="spinner || !emailCodeResendTimeout.isFinish()"
        (click)="$event.stopPropagation(); onSubmitResendEmailCode()">
        <ng-container *ngIf="!spinnerResendEmail">Resend email {{ emailCodeResendTimeout.formatSeconds() }}</ng-container>
        <i *ngIf="spinnerResendEmail" class="icon icon-wait spin"></i>
      </button>
    </ng-container>
  </form>
</ng-container>

<ng-container *ngIf="step === 'password-expired'">
  <div class="text-center email-sent-content">
    <h1 class="display-4 mb-20">Your password has expired</h1>
    <p class="note-text mb-20">We have sent you an email with a link to reset your password.</p>
    <p class="info-text mb-20">Didn't get the email? Check your spam folder or</p>
    <button
      class="btn btn-primary mb-20"
      [disabled]="spinner || !expiredPasswordTimeout || !expiredPasswordTimeout.isFinish()"
      (click)="onSubmitExpiredPassword(true)">
      <ng-container *ngIf="!spinner"> Resend email {{ expiredPasswordTimeout.formatSeconds() }}</ng-container>
      <i *ngIf="spinner" class="icon icon-wait spin"></i>
    </button>
  </div>
</ng-container>
